import './components/sliders.js';
// import './components/categorList';
import './components/product';
import './components/header';
import './components/products';
import './components/basket';
import './components/oforml';